<div class="gray-bg-rounded mb-3">
  <form>
    <div class="clientdetails-section mb-4">
      <header
        class="d-flex align-items-center justify-content-between pe-5 py-2 position-relative globalborder-btm-header pb-2">
        <h2 class="mb-0">Details</h2>
      </header>
      <div class="px-3 pt-3">
        <div class="row">
          <div class="col-6 leftfivecol">
            <div class="row">
              <div class="col-2 mb-3">
                <label class="title">Order #</label>
                <div class="text">
                  <a
                    class="link"
                    (click)="
                      onOrderSelection(invoicePreviewSummary?.orderNumber || '')
                    ">
                    {{ invoicePreviewSummary?.orderNumber }}
                  </a>
                </div>
              </div>
              <div class="col-3 mb-3">
                <label class="title">InhandDate</label>
                <div class="text">
                  <label
                    *ngIf="
                      invoicePreviewSummary?.inHandsDate | hidedynamicsdate
                    ">
                    {{
                      invoicePreviewSummary?.inHandsDate | date: "MM-dd-yyyy"
                    }}
                  </label>
                </div>
              </div>
              <div class="col-3 mb-3">
                <label class="title">Customer</label>
                <div class="text">
                  <a
                    class="link"
                    (click)="
                      onClientSelection(
                        invoicePreviewSummary?.customerAccount || ''
                      )
                    ">
                    {{ invoicePreviewSummary?.customerAccount }}
                  </a>
                </div>
              </div>
              <div class="col-2 mb-3">
                <label class="title">Buyer</label>
                <div class="text">
                  <label class="text">{{ invoicePreviewSummary?.buyer }}</label>
                </div>
              </div>
              <div class="col-2 pb-3 addseparator border-left">
                <label class="title">Total Sell</label>
                <div class="text">
                  <label class="text bold fontbold">
                    {{
                      invoicePreviewSummary?.totalSell
                        | currency: "USD" : "symbol" : "0.2-2"
                    }}
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-2 mb-3">
                <label class="title">Biller</label>
                <div class="text">
                  <label class="text">
                    {{ invoicePreviewSummary?.biller }}
                  </label>
                </div>
              </div>
              <div class="col-3 mb-3">
                <label class="title">Ready to bill</label>
                <div class="text">
                  <label class="text">
                    {{ invoicePreviewSummary?.readyToBill | number: "0.2-2" }}
                  </label>
                </div>
              </div>
              <div class="col-3 mb-3">
                <label class="title">Job Name</label>
                <label
                  *ngIf="invoicePreviewSummary?.lineProperty === 'Invoiced'"
                  class="text">
                  {{ invoicePreviewSummary?.jobName }}
                </label>
                <input
                  pInputText
                  *ngIf="invoicePreviewSummary?.lineProperty !== 'Invoiced'"
                  jniAutoCompleteBlocker
                  type="text"
                  id="jobName"
                  class="hideborder editableinputfield"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="jobName"
                  (focusout)="updateJobName()"
                  [disabled]="
                    invoicePreviewSummary?.lineProperty === 'Canceled'
                  " />
              </div>
              <div class="col-2 mb-3">
                <label class="title">Client PO</label>
                <label
                  *ngIf="invoicePreviewSummary?.lineProperty === 'Invoiced'"
                  class="text">
                  {{ invoicePreviewSummary?.clientPO }}
                </label>
                <input
                  pInputText
                  jniAutoCompleteBlocker
                  *ngIf="invoicePreviewSummary?.lineProperty !== 'Invoiced'"
                  type="text"
                  id="bac"
                  class="hideborder editableinputfield"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="customerPONumber"
                  (focusout)="updateCustomerPONumber()"
                  [disabled]="
                    invoicePreviewSummary?.lineProperty === 'Canceled'
                  " />
              </div>
              <div class="col-2 mb-3 addseparator border-left">
                <label class="title mb-1">GP</label>
                <div class="text">
                  <label class="text bold fontbold">
                    {{
                      invoicePreviewSummary?.gp
                        | currency: "USD" : "symbol" : "0.2-2"
                    }}
                  </label>
                </div>
              </div>

              <div class="col-2 mb-3">
                <!-- <div class="title">D365 Status</div>
                <div
                  class="text"
                  [title]="invoicePreviewSummary?.status"
                  style="
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  "
                >
                  {{ invoicePreviewSummary?.status }}
                </div> -->
              </div>
              <!-- <div class="col-2 mb-3 addseparator">
                <div class="title mb-1">Margin</div>
                <div class="text">
                  {{
                    invoicePreviewSummary?.margin
                      | currency: 'USD':'symbol':'0.2-2'
                  }}
                </div>
              </div> -->
            </div>
          </div>
          <div class="col-6 rightsixcol">
            <div class="row">
              <div class="col-2 pb-3">
                <label class="title">Total Cost</label>
                <div class="text">
                  <label class="text bold fontbold">
                    {{
                      invoicePreviewSummary?.totalCost
                        | currency: "USD" : "symbol" : "0.2-2"
                    }}
                  </label>
                </div>
              </div>
              <div class="col-2 pb-3">
                <label class="title">Net GP%</label>
                <div class="text">
                  <label class="text bold fontbold">
                    {{
                      invoicePreviewSummary?.netGPPercentage | number: "1.2-2"
                    }}%
                  </label>
                </div>
              </div>
              <div class="col-2 pb-3 addseparator border-left">
                <label class="title">Est Freight</label>
                <div class="text">
                  <label class="text">
                    {{
                      invoicePreviewSummary?.estFreight
                        | currency: "USD" : "symbol" : "0.2-2"
                    }}
                  </label>
                </div>
              </div>
              <div class="col-2 pb-3">
                <label class="title">Total Freight</label>
                <div class="text">
                  <a class="link" (click)="redirectToFreightChargesPage()">
                    <span class="freight-color"> </span
                    >{{
                      invoicePreviewSummary?.freightTotal
                        | currency: "USD" : "symbol" : "0.2-2"
                    }}</a
                  >
                </div>
              </div>
              <div class="col-2 pb-3 addseparator border-left">
                <label class="title">Client deposit</label>
                <div class="text">
                  <a class="link" (click)="redirectToClientDepositPage()">
                    <span class="freight-color"> </span
                    >{{
                      invoicePreviewSummary?.clientDeposit
                        | currency: "USD" : "symbol" : "0.2-2"
                    }}</a
                  >
                </div>
              </div>
              <div class="col-2 pb-3">
                <label class="title">Total Invoice</label>
                <div class="text">
                  <label class="text">
                    {{
                      invoicePreviewSummary?.totalInvoice
                        | currency: "USD" : "symbol" : "0.2-2"
                    }}
                  </label>
                </div>
              </div>

              <!-- <div class="col-2 mb-3">
                <div class="title">Freight Total</div>
                <div class="text">
                  <div class="text">
                    {{
                      invoicePreviewSummary?.freightTotal
                        | currency: 'USD':'symbol':'0.2-2'
                    }}
                  </div>
                </div>
              </div> -->
            </div>
            <div class="row">
              <div class="col-2 mb-3" *ngIf="showNetCommField">
                <label class="title">Net Com</label>
                <div class="text">
                  <label class="text">
                    {{
                      invoicePreviewSummary?.netComm
                        | currency: "USD" : "symbol" : "0.2-2"
                    }}
                  </label>
                </div>
              </div>

              <div class="col-2 mb-3">
                <label class="title">D365 Status</label>

                <div class="text">
                  <label
                    class="text"
                    [title]="invoicePreviewSummary?.status"
                    style="
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    ">
                    {{ invoicePreviewSummary?.lineProperty }}
                  </label>
                </div>
              </div>
              <!-- <div class="col-2 mb-3">
                <div class="title">Client deposit</div>
                <div class="text">
                  {{
                    invoicePreviewSummary?.clientDeposit
                      | currency: 'USD':'symbol':'0.2-2'
                  }}
                </div>
              </div> -->

              <div class="col-2 mb-3 addseparator border-left">
                <label class="title">Est Tax</label>
                <div class="text">
                  <label class="text">
                    {{
                      invoicePreviewSummary?.estTax
                        | currency: "USD" : "symbol" : "0.2-2"
                    }}
                  </label>
                </div>
              </div>
              <div class="col-2 mb-3">
                <label class="title">Total Tax</label>
                <div class="text">
                  <label class="text">
                    {{
                      invoicePreviewSummary?.totalTax
                        | currency: "USD" : "symbol" : "0.2-2"
                    }}
                  </label>
                </div>
              </div>

              <div class="col-4 mb-4 addseparator border-left">
                <label class="title">Freight Method</label>

                <div class="text">
                  <p-select
                    id="currency"
                    [appendTo]="'body'"
                    (onChange)="onShippingMethodChange($event)"
                    [(ngModel)]="shippingMethodCode"
                    [ngModelOptions]="{ standalone: true }"
                    [disabled]="
                      invoicePreviewSummary?.lineProperty === 'Invoiced' ||
                      invoicePreviewSummary?.lineProperty === 'Canceled'
                    "
                    [options]="shippingProductsList"
                    optionValue="modeCodeD365"
                    optionLabel="modeDescriptionD365">
                  </p-select>
                </div>
                <div class="title"></div>
                <div class="text"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<jni-modal-stacker
  class="modal-header-sticky"
  *ngIf="orderDisplayModal"
  [displayModal]="orderDisplayModal"
  (closeEvent)="closeModalForSaleOrder()">
  <h1 class="panelHeading">Order Summary</h1>
  <div class="panelBody">
    <jni-order-summary
      [isModal]="true"
      [saleOrderIdFromModal]="saleOrderId"
      (scrollHiddenStatus)="addScollHiddenClass()"
      (closeOrderSummaryModalEvent)="
        closeModalForSaleOrder()
      "></jni-order-summary>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="clientDisplayModal"
  [displayModal]="clientDisplayModal"
  (closeEvent)="closeModalForClient()">
  <h1 class="panelHeading">Client Summary</h1>
  <div class="panelBody">
    <jni-client-details
      [clientIdFromModal]="clientId"
      (scrollHiddenStatus)="addScollHiddenClass()"
      (closeEvent)="closeModalForClient()"
      [isModal]="true">
    </jni-client-details>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="freightChargesDisplayModal"
  [displayModal]="freightChargesDisplayModal"
  (closeEvent)="closeModalForFreight()">
  <h1 class="panelHeading">Freight Charges</h1>
  <div class="panelBody">
    <jni-invoice-preview-freight-charges [saleOrderId]="salesOrderId">
    </jni-invoice-preview-freight-charges>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="clientDepositDisplayModal"
  [displayModal]="clientDepositDisplayModal"
  (closeEvent)="closeModalForClientDeposit()">
  <h1 class="panelHeading">Client Deposit</h1>
  <div class="panelBody">
    <jni-invoice-preview-client-deposit
      [invoicePreviewNumber]="invoicePreviewNumber"
      (closeModalEvent)="closeModalForClientDeposit()">
    </jni-invoice-preview-client-deposit>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="freightChargesDisplayModal"
  [displayModal]="freightChargesDisplayModal"
  (closeEvent)="closeModalForFreight()">
  <h1 class="panelHeading">Freight Charges</h1>
  <div class="panelBody">
    <jni-freight-charges
      [isModal]="true"
      [saleOrderId]="invoicePreviewSummary.orderNumber || ''"
      (scrollHiddenStatus)="addScollHiddenClass()"
      (closeTrackingListModalEvent)="closeModalForFreight()">
    </jni-freight-charges>
  </div>
</jni-modal-stacker>
